import { useEffect } from 'react';
import { Browser } from '@capacitor/browser';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { useDispatch } from 'react-redux';
import { rerenderLayout } from '@/store/RenderProtectionRoute.slice';

export const useBrowserFinishedListener = (onClose?: () => void) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Only set up listener for Android/iOS
    if (Capacitor.getPlatform() !== 'web') {
      let listener: Promise<PluginListenerHandle> | undefined;

      const setupListener = async () => {
        listener = Browser.addListener('browserFinished', () => {
          dispatch(rerenderLayout()); // Dispatch renderLayout action
          if (onClose) {
            onClose(); // Call optional callback
          }
        });
      };

      setupListener();

      // Cleanup listener on component unmount
      return () => {
        listener?.then((handle) => handle.remove());
      };
    }
  }, [dispatch, onClose])
};